// LivestreamPinnedMessages.js
'use strict';
import { connect } from 'react-redux';
import getMeData from '../selector/getMeData.js';
import getLiveStreamPinnedMessages from '../selector/getLiveStreamPinnedMessages.js';
import LivestreamPinnedMessages from '../component/LivestreamPinnedMessages.jsx';
import removeLivestreamPinnedMessage from '../action/removeLivestreamPinnedMessage.js';

const mapStateToProps = (state, { streamId }) => {
  const meId = getMeData(state, 'id');
  const isStreamer = meId === streamId;
  return {
    isStreamer,
    pinnedMessages: getLiveStreamPinnedMessages(state, streamId),
  };
};
const mapDispatchToProps = dispatch => {
  return {
    removePinnedMessage: ({ streamId }) =>
      dispatch(removeLivestreamPinnedMessage({ streamId })),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LivestreamPinnedMessages);
